import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import LazyGruser from './LazyGruserZone';
import FatGruser from './GruserZoneLocal';
export default withFeatureBranch({
    seo_gruser: LazyGruser
})(FatGruser);
